// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img/menu/menu-toggle-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/img/menu/search-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/img/menu/user_edit.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Mixins **/
/** Vars (common) **/
/** app colors **/
/** Vars (MuiAlert) **/
/** main classes **/
.appNav_old-container__bnnWz {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  width: 100%;
}
.appNav_old-container__bnnWz.appNav_wrap__-zxqS {
  flex-wrap: wrap;
}
.appNav_old-container__bnnWz .appNav_box__aA0eL.appNav_col__3cRbz {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 10px;
}
.appNav_old-container__bnnWz .appNav_box__aA0eL.appNav_col__3cRbz > div {
  width: 100%;
}
.appNav_old-container__bnnWz .appNav_box__aA0eL.appNav_row__AoyYG {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.appNav_old-container__bnnWz form {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  flex-wrap: wrap;
  width: 100%;
}
.appNav_old-container__bnnWz form > .appNav_box__aA0eL.appNav_col__3cRbz {
  flex-basis: 33.33%;
}
@media screen and (min-width: 2560px) {
  .appNav_old-container__bnnWz form > .appNav_box__aA0eL.appNav_col__3cRbz {
    flex-basis: 0%;
    margin-right: 2em;
  }
}

@media screen and (max-width: 580px) {
  .appNav_old-container__bnnWz, .appNav_col__3cRbz, form {
    padding: 5px;
  }
}
@media screen and (max-width: 450px) {
  .appNav_old-container__bnnWz, .appNav_col__3cRbz, form {
    padding: 0px;
  }
}
.appNav_text-overflow-hidden__OytGR {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.appNav_icon__Hr6fR {
  color: var(--accent-color);
}

.appNav_richtext-output-wrap__9pvoB .appNav_se-video-container__hMycU figure {
  padding-bottom: 0 !important;
}

.appNav_userCompanyText__TzPjj {
  font-size: 12px;
  line-height: normal;
  padding-bottom: 8px;
}

.appNav_header__Vw-6- {
  width: 100%;
  position: fixed;
  left: 0;
  z-index: 1000;
  height: 120px;
  transition: width 0.35s ease;
  background: transparent;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.appNav_header__Vw-6- .appNav_logo__Szrz9 {
  width: 60px;
  height: 100%;
  cursor: pointer;
}
.appNav_header__Vw-6- .appNav_logo__Szrz9 img {
  margin: 5px 0px;
}
.appNav_header__Vw-6- .appNav_leftTools__u9uOR, .appNav_header__Vw-6- .appNav_rightTools__KiL3O {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.appNav_header__Vw-6- .appNav_leftTools__u9uOR button, .appNav_header__Vw-6- .appNav_rightTools__KiL3O button {
  margin: 0 5px;
}
.appNav_header__Vw-6- .appNav_rightTools__KiL3O .appNav_active__E6QvP {
  fill: var(--accent-color);
}
.appNav_header__Vw-6- .appNav_welcomeMsg__9jqMn {
  margin-left: auto;
  margin-right: 20px;
  color: #cecece;
}
.appNav_header__Vw-6- .appNav_userProfile__q-8yI {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.appNav_header__Vw-6- .appNav_userProfile__q-8yI .appNav_userAvatar__jgxi6 {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-position: center;
  background-size: cover;
  margin-right: 10px;
  margin-left: 10px;
  position: relative;
  cursor: pointer;
}
.appNav_header__Vw-6- .appNav_userProfile__q-8yI .appNav_userAvatar__jgxi6 img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 50%;
}
.appNav_header__Vw-6- .appNav_SideBarBurger__9p-h- {
  padding: 8px;
  border-radius: 8px;
  border: 2px solid transparent;
}
.appNav_header__Vw-6- .appNav_SideBarBurger__9p-h- .appNav_SideBarBurgerImage__\\+P2rQ {
  width: 40px;
  height: 25px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
}
.appNav_header__Vw-6- .appNav_SideBarBurgerOpen__fzsQD {
  border: 2px solid var(--accent-color);
}
.appNav_header__Vw-6- .appNav_SideBarBurgerOpen__fzsQD .appNav_SideBarBurgerImage__\\+P2rQ {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
}
.appNav_header__Vw-6- .appNav_HeaderLogo__lsUJ9 {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-left: 45px;
  margin-right: 20px;
}
.appNav_header__Vw-6- .appNav_HeaderLogo__lsUJ9 img {
  height: 62px;
}
@media screen and (max-width: 600px) {
  .appNav_header__Vw-6- .appNav_HeaderLogo__lsUJ9 {
    margin-left: 20px;
  }
}
.appNav_header__Vw-6- .appNav_HeaderSearchBlock__qtATM {
  max-width: 590px;
  width: 100%;
  height: 80px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  margin-left: auto;
}
@media screen and (max-width: 1023px) {
  .appNav_header__Vw-6- .appNav_HeaderSearchBlock__qtATM {
    height: 64px;
  }
}
.appNav_header__Vw-6- .appNav_HeaderSearchInputBlock__vQdil {
  position: relative;
  width: 100%;
  height: 48px;
}
@media screen and (max-width: 1023px) {
  .appNav_header__Vw-6- .appNav_HeaderSearchInputBlock__vQdil {
    height: 38px;
  }
}
.appNav_header__Vw-6- .appNav_HeaderSearchInputBlock__vQdil input {
  width: 100%;
  height: 48px;
  background: #232323;
  border-radius: 24px;
  padding: 0 24px 0 34px;
  border: none;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 130%;
  color: #666666;
}
@media screen and (max-width: 1023px) {
  .appNav_header__Vw-6- .appNav_HeaderSearchInputBlock__vQdil input {
    height: 38px;
  }
}
.appNav_header__Vw-6- .appNav_HeaderSearchIcon__wW7VS {
  position: absolute;
  top: 50%;
  left: 10px;
  width: 20px;
  height: 20px;
  transform: translateY(-50%);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
}

/** SideBar **/
.appNav_sideBar__R9WK- {
  position: absolute !important;
  top: 120px;
  left: 0;
  width: 320px;
  padding-top: 25px !important;
  padding-left: 25px !important;
  padding-bottom: 0px !important;
  padding-right: 10px !important;
  box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  z-index: 99;
  transform: translateX(-2000%);
}
.appNav_sideBar__R9WK-.appNav_open__bhmeF {
  transform: translateX(0%);
}
.appNav_sideBar__R9WK- .appNav_DesktopMenuScrollbars__53MmD {
  overflow-y: scroll;
  padding-bottom: 20px;
  -webkit-overflow-scrolling: touch;
  scrollbar-color: transparent transparent !important;
  scrollbar-width: none;
  /* For WebKit (Safari, Chrome, etc.) */
}
.appNav_sideBar__R9WK- .appNav_DesktopMenuScrollbars__53MmD::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.appNav_sideBar__R9WK- .appNav_MenuScrollbars__YR\\+zk > div:first-child {
  padding-right: 15px;
}
.appNav_sideBar__R9WK- .appNav_userBlock__ca8sq {
  display: flex;
  min-height: 100px;
}
.appNav_sideBar__R9WK- .appNav_userAvatar__jgxi6 {
  border-radius: 50%;
  margin-right: 42px;
}
.appNav_sideBar__R9WK- .appNav_userAvatarImage__DQMBf {
  display: block;
  width: 70px;
  height: 70px;
  background: #fff;
  border-radius: 50%;
  background-position: center;
  background-size: cover;
  overflow: hidden;
}
.appNav_sideBar__R9WK- .appNav_userAvatarImage__DQMBf img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.appNav_sideBar__R9WK- .appNav_userEditButton__CNGv2 {
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
  top: 45px;
  left: 80px;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat;
  background-position: center;
}
.appNav_sideBar__R9WK- .appNav_userName__GYphv {
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 170%;
  color: #FFFFFF;
}
.appNav_sideBar__R9WK- .appNav_userRolesText__uvPrO {
  font-size: 12px;
  line-height: 16px;
  background-color: var(--accent-color);
  float: left;
  padding: 0 10px;
  border-radius: 8px;
  color: var(--accent-text-color);
}
.appNav_sideBar__R9WK- .appNav_itemIconBlock__ITE60 {
  display: block;
  width: 60px;
}
.appNav_sideBar__R9WK- .appNav_itemIconImage__-ss1a {
  display: block;
  width: 22px;
  height: 22px;
  margin: 0 auto;
  background-repeat: no-repeat;
}
.appNav_sideBar__R9WK- .appNav_item__4nUC4 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  max-width: 315px;
  min-height: 64px;
  margin: 10px 0;
  padding: 0;
  border: 1px solid transparent;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}
.appNav_sideBar__R9WK- .appNav_item__4nUC4 a {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-right: 10px;
  height: 64px;
  text-align: left;
}
.appNav_sideBar__R9WK- .appNav_item__4nUC4.appNav_withSub__kehCm {
  margin-bottom: 0 !important;
  padding-right: 10px;
}
.appNav_sideBar__R9WK- .appNav_item__4nUC4.appNav_withSub__kehCm svg {
  position: absolute;
  right: 0;
}
.appNav_sideBar__R9WK- .appNav_item__4nUC4.appNav_active__E6QvP {
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.2);
  background-color: var(--accent-color);
  background-repeat: no-repeat;
}
.appNav_sideBar__R9WK- .appNav_item__4nUC4.appNav_active__E6QvP p {
  z-index: 999;
}
.appNav_sideBar__R9WK- .appNav_item__4nUC4 .appNav_activeMenuBg__dp673 {
  position: absolute;
}
.appNav_sideBar__R9WK- .appNav_item__4nUC4 .appNav_activeMenuBg__dp673 path {
  fill: rgba(var(--accent-color-r), var(--accent-color-g10), var(--accent-color-b), 1);
}
.appNav_sideBar__R9WK- .appNav_item__4nUC4:last-of-type {
  margin-bottom: 30px;
}
.appNav_sideBar__R9WK- .appNav_item__4nUC4 .appNav_icon__Hr6fR {
  color: var(--accent-color);
  height: 20px;
  position: absolute;
  right: 8px;
  top: 10px;
  transform: translate(50%, -50%);
}
.appNav_sideBar__R9WK- .appNav_subMenu__QSi3b {
  background-color: rgba(var(--accent-color-r), var(--accent-color-g), var(--accent-color-b), 0.1);
  border-radius: 6px;
  transition: all 0.25s ease;
  max-width: 315px;
}
.appNav_sideBar__R9WK- .appNav_subMenu__QSi3b > li {
  padding: 0;
}
.appNav_sideBar__R9WK- .appNav_subMenu__QSi3b > li:hover {
  background-color: rgba(var(--accent-color-r), var(--accent-color-g), var(--accent-color-b), 0.2);
}
.appNav_sideBar__R9WK- .appNav_subMenu__QSi3b > li a {
  display: flex;
  align-items: center;
  width: 100%;
  text-align: left;
  padding: 5px;
  padding-right: 20px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.appNav_sideBar__R9WK- .appNav_subMenu__QSi3b > li a div {
  display: block;
  width: 10px;
  height: 10px;
  background-color: rgba(var(--accent-color-r), var(--accent-color-g), var(--accent-color-b), 0.5);
  margin-left: 15px;
  margin-right: 15px;
  border-radius: 50%;
}
.appNav_sideBar__R9WK- .appNav_subMenu__QSi3b > li.appNav_active__E6QvP div {
  background-color: var(--accent-color);
}
.appNav_sideBar__R9WK- .appNav_subMenu__QSi3b .appNav_subItem__NMs3I {
  background-color: rgba(var(--accent-color-r), var(--accent-color-g), var(--accent-color-b), 0.1);
}

.appNav_exchangeViewSwitchButton__LhJNh {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 75px;
  height: 75px;
  min-width: 75px;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}
.appNav_exchangeViewSwitchButton__LhJNh:hover {
  background: #343434;
}
@media screen and (max-width: 1023px) {
  .appNav_exchangeViewSwitchButton__LhJNh {
    width: 60px;
    min-width: 60px;
    height: 60px;
  }
  .appNav_exchangeViewSwitchButton__LhJNh svg {
    width: 30px !important;
    height: 30px !important;
  }
}
@media screen and (max-width: 640px) {
  .appNav_exchangeViewSwitchButton__LhJNh {
    width: 52px;
    min-width: 52px;
    height: 52px;
  }
  .appNav_exchangeViewSwitchButton__LhJNh svg {
    width: 28px !important;
    height: 28px !important;
  }
}
@media screen and (max-width: 480px) {
  .appNav_exchangeViewSwitchButton__LhJNh {
    justify-self: flex-end;
  }
}`, "",{"version":3,"sources":["webpack://./src/sass/_settings.sass","webpack://./src/components/AppNav/appNav.module.sass"],"names":[],"mappings":"AAAA,aAAA;AAeA,oBAAA;AAgBA,iBAAA;AA0BA,sBAAA;AAGA,mBAAA;AACA;EA3DE,aAAA;EACA,mBA4DM;EA3DN,8BA2DW;EA1DX,uBA0D0B;EAC1B,kBAAA;EACA,WAAA;ACrDF;ADsDE;EACE,eAAA;ACpDJ;ADsDI;EAnEF,aAAA;EACA,sBAmEU;EAlEV,2BAkEkB;EAjElB,uBAiE8B;EAC1B,eAAA;ACjDN;ADkDM;EACE,WAAA;AChDR;ADiDI;EAxEF,aAAA;EACA,mBAwEU;EAvEV,2BAuEe;EAtEf,uBAsE2B;EACvB,WAAA;AC5CN;AD6CE;EACE,aAjDK;EA3BP,aAAA;EACA,mBA4EQ;EA3ER,2BA2Ea;EA1Eb,uBA0EyB;EACvB,kBAAA;EACA,eAAA;EACA,WAAA;ACxCJ;ADyCI;EACE,kBAAA;ACvCN;ADwCM;EAFF;IAGI,cAAA;IACA,iBAAA;ECrCN;AACF;;ADsCA;EAEE;IACE,YAFO;EClCT;AACF;ADoCA;EAEE;IACE,YAFO;ECjCT;AACF;ADoCA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AClCF;;ADoCA;EACE,0BAtFO;ACqDT;;ADqCI;EACE,4BAAA;AClCN;;AA1EA;EACI,eAAA;EACA,mBAAA;EACA,mBAAA;AA6EJ;;AA3EA;EACI,WAAA;EACA,eAAA;EACA,OAAA;EACA,aAAA;EACA,aDyCY;ECxCZ,4BAAA;EACA,uBAAA;EDXF,aAAA;EACA,mBCWQ;EDVR,2BCUa;EDTb,mBCSyB;AAiF3B;AAhFI;EACI,WAAA;EACA,YAAA;EACA,eAAA;AAkFR;AAjFQ;EACI,eAAA;AAmFZ;AAlFI;EDnBF,aAAA;EACA,mBCmBY;EDlBZ,uBCkBiB;EDjBjB,mBCiByB;AAuF3B;AAtFQ;EACI,aAAA;AAwFZ;AAtFQ;EACI,yBDTH;ACiGT;AAvFI;EACI,iBAAA;EACA,kBDDC;ECED,cDPD;ACgGP;AAxFI;ED9BF,aAAA;EACA,mBC8BY;ED7BZ,uBC6BkB;ED5BlB,mBC4B0B;AA6F5B;AA3FQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AA6FZ;AA5FY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AA8FhB;AA5FI;EACI,YAAA;EACA,kBAAA;EACA,6BAAA;AA8FR;AA7FQ;EACI,WAAA;EACA,YAAA;EACA,6DAAA;AA+FZ;AA9FI;EACI,qCAAA;AAgGR;AA/FQ;EACI,6DAAA;AAiGZ;AAhGI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAkGR;AAjGQ;EACI,YAAA;AAmGZ;AAlGQ;EARJ;IASQ,iBAAA;EAqGV;AACF;AApGI;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAsGR;AArGQ;EATJ;IAUQ,YAAA;EAwGV;AACF;AAxGI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AA0GR;AAzGQ;EAJJ;IAKQ,YAAA;EA4GV;AACF;AA5GQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA8GZ;AA7GY;EAZJ;IAaQ,YAAA;EAgHd;AACF;AAhHI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,6DAAA;AAkHR;;AAhHA,cAAA;AACA;EACI,6BAAA;EACA,UDjEY;ECkEZ,OAAA;EACA,YDlEY;ECmEZ,4BAAA;EACA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,2CAAA;EACA,mBAAA;EACA,WAAA;EACA,6BAAA;AAmHJ;AAjHI;EACI,yBAAA;AAmHR;AAlHI;EACI,kBAAA;EACA,oBAAA;EACA,iCAAA;EACA,mDAAA;EACA,qBAAA;EAEA,sCAAA;AAmHR;AAlHQ;EACI,QAAA;EACA,SAAA;AAoHZ;AAlHQ;EACI,mBAAA;AAoHZ;AAnHI;EACI,aAAA;EACA,iBAAA;AAqHR;AApHI;EACI,kBAAA;EACA,kBAAA;AAsHR;AArHI;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,sBAAA;EACA,gBAAA;AAuHR;AAtHQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAwHZ;AAvHI;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,kEAAA;EACA,2BAAA;AAyHR;AAvHI;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAyHR;AAxHI;EACI,eAAA;EACA,iBAAA;EACA,qCDtKC;ECuKD,WAAA;EACA,eAAA;EACA,kBAAA;EACA,+BDzKM;ACmSd;AAzHI;EACI,cAAA;EACA,WAAA;AA2HR;AA1HI;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,4BAAA;AA4HR;AA3HI;EDpMF,aAAA;EACA,mBCoMY;EDnMZ,2BCmMiB;EDlMjB,mBCkM6B;EACvB,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;EACA,6BAAA;EACA,0CAAA;EACA,mBAAA;AAgIR;AA7HQ;EACI,WAAA;EDhNV,aAAA;EACA,mBCiNgB;EDhNhB,2BCgNqB;ED/MrB,mBC+MiC;EACvB,mBAAA;EACA,YAAA;EACA,gBAAA;AAiIZ;AAhIQ;EACI,2BAAA;EACA,mBAAA;AAkIZ;AAjIY;EACI,kBAAA;EACA,QAAA;AAmIhB;AAlIQ;EACI,gDAAA;EACA,qCD9MH;EC+MG,4BAAA;AAoIZ;AAnIY;EACI,YAAA;AAqIhB;AApIQ;EACI,kBAAA;AAsIZ;AApIY;EACI,oFAAA;AAsIhB;AApIQ;EACI,mBAAA;AAsIZ;AArIQ;EACI,0BD3NH;EC4NG,YAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,+BAAA;AAuIZ;AAtII;EACI,gGAAA;EACA,kBAAA;EACA,0BAAA;EACA,gBAAA;AAwIR;AAvIQ;EACI,UAAA;AAyIZ;AAxIY;EACI,gGAAA;AA0IhB;AAzIY;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EAEA,YAAA;EACA,mBDtOP;ECuOO,gBAAA;EACA,mBAAA;AA0IhB;AAzIgB;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,gGAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AA2IpB;AAzIgB;EACI,qCD9PX;ACyYT;AA1IQ;EACI,gGAAA;AA4IZ;;AA1IA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,uCAAA;AA6IJ;AA3II;EACI,mBAAA;AA6IR;AA3II;EAhBJ;IAiBQ,WAAA;IACA,eAAA;IACA,YAAA;EA8IN;EA5IM;IACI,sBAAA;IACA,uBAAA;EA8IV;AACF;AA7II;EAzBJ;IA0BQ,WAAA;IACA,eAAA;IACA,YAAA;EAgJN;EA9IM;IACI,sBAAA;IACA,uBAAA;EAgJV;AACF;AA/II;EAlCJ;IAmCQ,sBAAA;EAkJN;AACF","sourcesContent":["/** Mixins **/\n=flex($der, $justy, $align)\n  display: flex\n  flex-direction: $der\n  justify-content: $justy\n  align-items: $align\n\n=shadow()\n  box-shadow: -5px 5px 10px 0px rgba(#000, .35)\n\n=staticHeight($height)\n  min-height: $height\n  max-height: $height\n  height: $height\n\n/** Vars (common) **/\n$main: #2F2F2F\n$main_background: #191818\n$accent: var(--accent-color)\n$accent_text: var(--accent-text-color)\n$accent_r: var(--accent-color-r)\n$accent_g: var(--accent-color-g)\n$accent_g10: var(--accent-color-g10)\n$accent_b: var(--accent-color-b)\n$text: #cecece\n$error: #f44336\n$success: rgb(102, 187, 106)\n$container_background_color: #1B1B1B\n$container_item_background_color: #212121\n$gutter: 20px\n\n/** app colors **/\n$soft_teal: #84aaaf\n$fiery_red: #ff3131\n$muted_red: #e85a4f\n$app_red: #B83336\n$soft_creamy: #f5e8dd\n$light_gray: #535353\n$golden_yellow: #ffc107\n$orange: #ffa725\n$app_orange: #DB890E\n$warm_orange: #e3a869\n$faded_pink: #d69fa2\n$purple: #8868a3\n$app_purple: #7E51A3\n$light_blue: #79a8d1\n$app_green: #16962F\n$retro_green: #4a7c59\n$deep_blue: #406ca8\n\n$main_block_top_padding: 130px\n$main_block_top_padding_s: 70px\n$header_height: 120px\n$sidebar_width: 320px\n\n$table_row_height: 55px\n\n/** Vars (MuiAlert) **/\n$MuiAlert_main_color: rgb(166, 213, 250)\n\n/** main classes **/\n.old-container\n  //padding: $gutter\n  +flex(row, space-between, flex-start)\n  position: relative\n  width: 100%\n  &.wrap\n    flex-wrap: wrap\n  .box\n    &.col\n      +flex(column, flex-start, flex-start)\n      padding: 0 calc($gutter/2)\n      > div\n        width: 100%\n    &.row\n      +flex(row, flex-start, flex-start)\n      width: 100%\n  form\n    padding: $gutter\n    +flex(row, flex-start, flex-start)\n    position: relative\n    flex-wrap: wrap\n    width: 100%\n    > .box.col\n      flex-basis: 33.33%\n      @media screen and ( min-width: 2560px )\n        flex-basis: 0%\n        margin-right: 2em\n\n@media screen and ( max-width: 580px )\n  $gutter: 5px\n  .old-container, .col, form\n    padding: $gutter\n@media screen and ( max-width: 450px )\n  $gutter: 0px\n  .old-container, .col, form\n    padding: $gutter\n\n.text-overflow-hidden\n  overflow: hidden\n  text-overflow: ellipsis\n  white-space: nowrap\n\n.icon\n  color: $accent\n\n.richtext-output-wrap\n  .se-video-container\n    figure\n      padding-bottom: 0 !important\n","@import '../../sass/settings'\n.userCompanyText\n    font-size: 12px\n    line-height: normal\n    padding-bottom: 8px\n\n.header\n    width: 100%\n    position: fixed\n    left: 0\n    z-index: 1000\n    height: $header_height\n    transition: width .35s ease\n    background: transparent\n    +flex(row, flex-start, center)\n    .logo\n        width: 60px\n        height: 100%\n        cursor: pointer\n        img\n            margin: 5px 0px\n    .leftTools, .rightTools\n        +flex(row, center, center)\n        button\n            margin: 0 5px\n    .rightTools\n        .active\n            fill: $accent\n    .welcomeMsg\n        margin-left: auto\n        margin-right: $gutter\n        color: $text\n    .userProfile\n        +flex(row , center, center)\n        // margin-left: auto\n        .userAvatar\n            width: 48px\n            height: 48px\n            border-radius: 50%\n            background-position: center\n            background-size: cover\n            margin-right: calc($gutter/2)\n            margin-left: calc($gutter/2)\n            position: relative\n            cursor: pointer\n            img\n                width: 100%\n                height: 100%\n                object-fit: contain\n                border-radius: 50%\n\n    .SideBarBurger\n        padding: 8px\n        border-radius: 8px\n        border: 2px solid transparent\n        .SideBarBurgerImage\n            width: 40px\n            height: 25px\n            background: url(\"../../assets/img/menu/menu-toggle-icon.png\") no-repeat\n    .SideBarBurgerOpen\n        border: 2px solid $accent\n        .SideBarBurgerImage\n            background: url(\"../../assets/img/menu/menu-toggle-icon.png\") no-repeat\n    .HeaderLogo\n        display: flex\n        align-items: center\n        cursor: pointer\n        margin-left: 45px\n        margin-right: 20px\n        img\n            height: 62px\n        @media screen and ( max-width: 600px )\n            margin-left: 20px\n\n    .HeaderSearchBlock\n        max-width: 590px\n        width: 100%\n        height: 80px\n        border-radius: 10px\n        display: flex\n        align-items: center\n        padding-left: 20px\n        margin-left: auto\n        @media screen and ( max-width: 1023px )\n            height: 64px\n    .HeaderSearchInputBlock\n        position: relative\n        width: 100%\n        height: 48px\n        @media screen and ( max-width: 1023px )\n            height: 38px\n        input\n            width: calc(100%)\n            height: 48px\n            background: #232323\n            border-radius: 24px\n            padding: 0 24px 0 34px\n            border: none\n            font-style: normal\n            font-weight: 400\n            font-size: 16px\n            line-height: 130%\n            color: #666666\n            @media screen and ( max-width: 1023px )\n                height: 38px\n    .HeaderSearchIcon\n        position: absolute\n        top: 50%\n        left: 10px\n        width: 20px\n        height: 20px\n        transform: translateY(-50%)\n        background: url(\"../../assets/img/menu/search-icon.png\") no-repeat\n\n/** SideBar **/\n.sideBar\n    position: absolute !important\n    top: $header_height\n    left: 0\n    width: $sidebar_width\n    padding-top: 25px !important\n    padding-left: 25px !important\n    padding-bottom: 0px !important\n    padding-right: 10px !important\n    box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.15)\n    border-radius: 12px\n    z-index: 99\n    transform: translateX(-2000%)\n\n    &.open\n        transform: translateX(0%)\n    .DesktopMenuScrollbars\n        overflow-y: scroll\n        padding-bottom: 20px\n        -webkit-overflow-scrolling: touch\n        scrollbar-color: transparent transparent !important\n        scrollbar-width: none\n\n        /* For WebKit (Safari, Chrome, etc.) */\n        &::-webkit-scrollbar\n            width: 0\n            height: 0\n    .MenuScrollbars\n        > div:first-child\n            padding-right: 15px\n    .userBlock\n        display: flex\n        min-height: 100px\n    .userAvatar\n        border-radius: 50%\n        margin-right: 42px\n    .userAvatarImage\n        display: block\n        width: 70px\n        height: 70px\n        background: #fff\n        border-radius: 50%\n        background-position: center\n        background-size: cover\n        overflow: hidden\n        img\n            width: 100%\n            height: 100%\n            object-fit: contain\n    .userEditButton\n        cursor: pointer\n        width: 30px\n        height: 30px\n        border-radius: 50%\n        position: absolute\n        top: 45px\n        left: 80px\n        background: #fff url(\"../../assets/img/menu/user_edit.png\") no-repeat\n        background-position: center\n\n    .userName\n        font-style: normal\n        font-weight: 600\n        font-size: 20px\n        line-height: 170%\n        color: #FFFFFF\n    .userRolesText\n        font-size: 12px\n        line-height: 16px\n        background-color: $accent\n        float: left\n        padding: 0 10px\n        border-radius: 8px\n        color: $accent_text\n    .itemIconBlock\n        display: block\n        width: 60px\n    .itemIconImage\n        display: block\n        width: 22px\n        height: 22px\n        margin: 0 auto\n        background-repeat: no-repeat\n    .item\n        +flex(row, flex-start, center)\n        max-width: 315px\n        min-height: 64px\n        margin: calc($gutter/2) 0\n        padding: 0\n        border: 1px solid transparent\n        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2)\n        border-radius: 10px\n\n        //right: 15px\n        a\n            width: 100%\n            // height: 100%\n            +flex(row, flex-start, center)\n            padding-right: calc($gutter/2)\n            height: 64px\n            text-align: left\n        &.withSub\n            margin-bottom: 0 !important\n            padding-right: calc($gutter/2)\n            svg\n                position: absolute\n                right: 0\n        &.active\n            box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.2)\n            background-color: $accent\n            background-repeat: no-repeat\n            p\n                z-index: 999\n        .activeMenuBg\n            position: absolute\n            g\n            path\n                fill: rgba($accent_r, $accent_g10, $accent_b, 1)\n\n        &:last-of-type\n            margin-bottom: 30px\n        .icon\n            color: $accent\n            height: 20px\n            position: absolute\n            right: 8px\n            top: 10px\n            transform: translate(50%, -50%)\n    .subMenu\n        background-color: rgba($accent_r, $accent_g, $accent_b, .1)\n        border-radius: 6px\n        transition: all .25s ease\n        max-width: 315px\n        > li\n            padding: 0\n            &:hover\n                background-color: rgba($accent_r, $accent_g, $accent_b, .2)\n            a\n                display: flex\n                align-items: center\n                width: 100%\n                text-align: left\n                // +flex(row, flex-end, center)\n                padding: 5px\n                padding-right: $gutter\n                padding-top: 8px\n                padding-bottom: 8px\n                div\n                    display: block\n                    width: 10px\n                    height: 10px\n                    background-color: rgba($accent_r, $accent_g, $accent_b, .5)\n                    margin-left: 15px\n                    margin-right: 15px\n                    border-radius: 50%\n            &.active\n                div\n                    background-color: $accent\n        .subItem\n            background-color: rgba($accent_r, $accent_g, $accent_b, .1)\n\n.exchangeViewSwitchButton\n    display: flex\n    flex-direction: column\n    align-items: center\n    justify-content: center\n    width: 75px\n    height: 75px\n    min-width: 75px\n    border-radius: 10px\n    position: relative\n    cursor: pointer\n    transition: background 0.2s ease-in-out\n\n    &:hover\n        background: #343434\n\n    @media screen and ( max-width: 1023px )\n        width: 60px\n        min-width: 60px\n        height: 60px\n\n        svg\n            width: 30px !important\n            height: 30px !important\n\n    @media screen and ( max-width: 640px )\n        width: 52px\n        min-width: 52px\n        height: 52px\n\n        svg\n            width: 28px !important\n            height: 28px !important\n\n    @media screen and ( max-width: 480px )\n        justify-self: flex-end"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"old-container": `appNav_old-container__bnnWz`,
	"wrap": `appNav_wrap__-zxqS`,
	"box": `appNav_box__aA0eL`,
	"col": `appNav_col__3cRbz`,
	"row": `appNav_row__AoyYG`,
	"text-overflow-hidden": `appNav_text-overflow-hidden__OytGR`,
	"icon": `appNav_icon__Hr6fR`,
	"richtext-output-wrap": `appNav_richtext-output-wrap__9pvoB`,
	"se-video-container": `appNav_se-video-container__hMycU`,
	"userCompanyText": `appNav_userCompanyText__TzPjj`,
	"header": `appNav_header__Vw-6-`,
	"logo": `appNav_logo__Szrz9`,
	"leftTools": `appNav_leftTools__u9uOR`,
	"rightTools": `appNav_rightTools__KiL3O`,
	"active": `appNav_active__E6QvP`,
	"welcomeMsg": `appNav_welcomeMsg__9jqMn`,
	"userProfile": `appNav_userProfile__q-8yI`,
	"userAvatar": `appNav_userAvatar__jgxi6`,
	"SideBarBurger": `appNav_SideBarBurger__9p-h-`,
	"SideBarBurgerImage": `appNav_SideBarBurgerImage__+P2rQ`,
	"SideBarBurgerOpen": `appNav_SideBarBurgerOpen__fzsQD`,
	"HeaderLogo": `appNav_HeaderLogo__lsUJ9`,
	"HeaderSearchBlock": `appNav_HeaderSearchBlock__qtATM`,
	"HeaderSearchInputBlock": `appNav_HeaderSearchInputBlock__vQdil`,
	"HeaderSearchIcon": `appNav_HeaderSearchIcon__wW7VS`,
	"sideBar": `appNav_sideBar__R9WK-`,
	"open": `appNav_open__bhmeF`,
	"DesktopMenuScrollbars": `appNav_DesktopMenuScrollbars__53MmD`,
	"MenuScrollbars": `appNav_MenuScrollbars__YR+zk`,
	"userBlock": `appNav_userBlock__ca8sq`,
	"userAvatarImage": `appNav_userAvatarImage__DQMBf`,
	"userEditButton": `appNav_userEditButton__CNGv2`,
	"userName": `appNav_userName__GYphv`,
	"userRolesText": `appNav_userRolesText__uvPrO`,
	"itemIconBlock": `appNav_itemIconBlock__ITE60`,
	"itemIconImage": `appNav_itemIconImage__-ss1a`,
	"item": `appNav_item__4nUC4`,
	"withSub": `appNav_withSub__kehCm`,
	"activeMenuBg": `appNav_activeMenuBg__dp673`,
	"subMenu": `appNav_subMenu__QSi3b`,
	"subItem": `appNav_subItem__NMs3I`,
	"exchangeViewSwitchButton": `appNav_exchangeViewSwitchButton__LhJNh`
};
export default ___CSS_LOADER_EXPORT___;
